<template lang="pug">
BlueSearch(@presearch="extendType", #default="{ loaded }")
	.searchResults
		.searchResults-list
			SearchResults
				template(#item="{ result, openInNewWindow, formatDate, reloading }")
					Result(
						:result="result",
						:openInNewWindow="openInNewWindow",
						:formatDate="formatDate"
					)
		SearchPagination
			template(#default="{ navigate, enableNext }")
				button.searchResultsMore-btn.btn(@click.stop.prevent="navigate(1)", v-show="enableNext", :class="{ 'is-loading': loaded }") Show More News
</template>

<script>
import Result from "./components/Result.vue";
export default {
	name: "OCCSearch",
	components: {
		Result,
	},
	data() {
		return {
			typeName: false
		}
	},
	methods: {
		extendType({extend, done}) {
			extend(extended => {
				// if the typeName value exists (below in created) extende the type
				// if not, do not extend type
				// -- typeName used for both fieldName and displayName because only displayName is used by BE,  
				// fieldName is ignored by BE, so typeName passed in there as dummy text 
				if (this.typeName) {
					extended.type = {
						fieldName: this.typeName,
						displayName: this.typeName
					};
				}
				return extended;
			});
			done();
		},
	},
	created() {
		// if the data-type-filter attr exists and has a non-empty value, then
		// set the typeName data variable to its value, to be used in extendType above
		if (!!this.$root.options.typeFilter) {
			this.typeName = this.$root.options.typeFilter;
			console.log(this.typeName);
		}
	}
};
</script>

<style lang="scss" scoped>
#bluesearch {
	--link-color: #{$mirage};
	--link-hover-color: #{$mirage};
	--loader-color: #{$sushi};
	--pagination-number-color: #{$darkGray};
	--pagination-number-background: transparent;
	--pagination-number-hover-color: #{$white};
	--pagination-number-hover-background: #{$gray};
	--pagination-number-active-color: #{$white};
	--pagination-number-active-background: #{$mirage};
	--pagination-nav-hover-background: #{$sushi};
	--font-weight: 300;
	--font-family: "Roboto Slab",Arial,Helvetica,sans-serif;
	--focus-color: #{$mirage};
	--line-height: 1.5;
}

.searchResults {
	display: flex;
	flex-direction: column;
	width: 100%;
}
</style>

<style lang="scss">
.updates-and-news {
	.search__results {
		gap: 0;
	}
	.search-pagination {
		margin: 1rem 0;
	}
	.searchResultsMore-btn {
		margin: 1rem 0;
	}
}
</style>